'use client';

import { cn } from '@holistic/components';

import type { ComponentType, ReactNode } from 'react';

type InfoBannerTone = 'info' | 'warning';

const TONE_CLASSES: Record<
  InfoBannerTone,
  { wrapper: string; badge: string; title: string; body: string }
> = {
  info: {
    wrapper: 'border-primary/15 bg-primary/5',
    badge: 'bg-primary/10 text-primary',
    title: 'text-gray-900',
    body: 'text-gray-500',
  },
  warning: {
    wrapper: 'border-amber-100 bg-amber-50/70',
    badge: 'bg-amber-100 text-amber-700',
    title: 'text-amber-900',
    body: 'text-amber-700/80',
  },
};

type InfoBannerProps = {
  icon: ComponentType<{ className?: string }>;
  title: string;
  children: ReactNode;
  tone?: InfoBannerTone;
};

/** Kargo adımlarındaki kısa bilgilendirme şeridi. */
const InfoBanner = ({
  icon: Icon,
  title,
  children,
  tone = 'info',
}: InfoBannerProps) => {
  const classes = TONE_CLASSES[tone];

  return (
    <div
      className={cn(
        'flex items-start gap-3.5 rounded-2xl border p-4',
        classes.wrapper
      )}
    >
      <span
        className={cn(
          'flex size-9 shrink-0 items-center justify-center rounded-full',
          classes.badge
        )}
      >
        <Icon className="size-4.5" />
      </span>

      <div className="min-w-0 flex-1">
        <p className={cn('text-sm font-semibold', classes.title)}>{title}</p>
        <p className={cn('mt-0.5 text-xs leading-relaxed', classes.body)}>
          {children}
        </p>
      </div>
    </div>
  );
};

export default InfoBanner;
